import React from "react";
import { Modal } from "react-bootstrap";
import { useForm, Controller, Resolver } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import FormTextInput from "src/_common/components/form-elements/textinput/formTextInput";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";

interface UpdateDisplayNameModalProps {
  onClose: () => void;
  shouldShow: boolean;
}

interface UpdateDisplayNameModalValues {
  display_name: string;
}

const updateDisplayNameModalSchema = yup
  .object<UpdateDisplayNameModalValues>({
    display_name: yup.string().required("Display name is required"),
  })
  .required();

export default function UpdateDisplayNameModal({ onClose, shouldShow }: UpdateDisplayNameModalProps) {
  const { control, formState: { errors }, handleSubmit } = useForm<UpdateDisplayNameModalValues>({
    resolver: yupResolver(updateDisplayNameModalSchema) as unknown as Resolver<UpdateDisplayNameModalValues>,
    defaultValues: {
      display_name: "",
    },
  });

  const userApi = useUserApi();
  const userAction = useAppUserAction();

  const onSubmit = (values: UpdateDisplayNameModalValues) => {
    // console.log({values})
    const params = {
      display_name: values?.display_name,
    };
    userApi.callUpdateDisplayName(
      params,
      (_message: string, resp: unknown) => {
        if (resp && typeof resp === "object" && "display_name" in resp) {
          userAction.updateDisplayName(String((resp as { display_name: unknown }).display_name));
        }
        onClose();
        // console.log({resp})
      },
      (_message: string) => {}
    );
  };

  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Body bsPrefix={"main-container"}>
          <div className="modal-body">
            <h4 className="rider-name-content">Please enter your display name</h4>
            <div className="mb-3">
              {/* <label className="form-label">Display Name</label> */}
              <Controller
                control={control}
                name="display_name"
                render={({ field }) => (
                  <FormTextInput
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    value={field.value}
                    inputRef={field.ref}
                    name={field.name}
                    type="text"
                    error={errors.display_name}
                    placeholder="Display Name"
                  />
                )}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button
              type="button"
              className="rkmd-btn btn-lg btn-orange ripple-effect w-100 mt-3"
              onClick={handleSubmit(onSubmit)}
            >
              Update
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
